import { MOBILE_SCREEN_WIDTH } from 'constants/design'

export const clearModalStyle = (element, fixedTop) => {
  if (!element) {
    return
  }

  const modal = element
  modal.style.height = null
  modal.style.marginLeft = null
  if (!fixedTop) {
    modal.style.marginTop = null
  }
}

export const setModalHorizontalPosition = aModal => {
  if (!aModal) {
    return
  }
  const modal = aModal
  modal.style.marginLeft = `${-(modal.offsetWidth / 2)}px`
}

export const setModalVerticalPosition = (aModal, fixedTop = false) => {
  if (!aModal) {
    return
  }
  const modal = aModal
  const modalHeight = modal.offsetHeight > window.innerHeight ? window.innerHeight - 90 : modal.offsetHeight
  const marginTop = -(modal.offsetHeight / 2)
  modal.style.height = `${modalHeight}px`
  if (!fixedTop || modal.style.marginTop === null || modal.style.marginTop > marginTop) {
    modal.style.marginTop = `${marginTop}px`
  }
}

export const setModalStyle = (element, fixedTop = false) => {
  if (!element) {
    return
  }
  const modal = element
  clearModalStyle(modal, fixedTop)
  setModalHorizontalPosition(modal)
  setModalVerticalPosition(modal, fixedTop)
}

export const setModalStyleOnMobileWidth = modal => {
  // enabled over 620px
  if (window.innerWidth > MOBILE_SCREEN_WIDTH) {
    setModalStyle(modal)
  }
}
